(() => {
  const initializeReveals = (scope = document) => {
    scope.querySelectorAll('[data-about-reveal]').forEach(element => element.classList.add('is-visible'));
  };

  const initializeFaq = (scope = document) => {
    scope.querySelectorAll('[data-about-faq]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const items = [...root.querySelectorAll('[data-faq-item]')];
      items.forEach(item => item.addEventListener('toggle', () => {
        item.querySelector('summary')?.setAttribute('aria-expanded', String(item.open));
        if (!item.open) return;
        items.filter(other => other !== item && other.open).forEach(other => { other.open = false; });
      }));
    });
  };

  const pauseMarquees = () => document.querySelectorAll('[data-about-marquee]').forEach(marquee => marquee.classList.toggle('is-paused', document.hidden));
  const initialize = scope => { initializeReveals(scope); initializeFaq(scope); pauseMarquees(); };
  initialize(document);
  document.addEventListener('visibilitychange', pauseMarquees);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => {
    const item = event.target.closest?.('[data-faq-item]');
    if (item) { item.open = true; item.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
  });
})();
